import {
    APP_ERROR_TAG,
    LAUNCHER_TAG,
    MENU_TAG,
    PROMPT_TAG,
    HEADER_TAG,
} from 'common/tags'

import Launcher from 'wrapper/containers/Launcher'
import Menu from 'wrapper/containers/Menu'
import Prompt from 'wrapper/containers/Prompt'
import Header from 'wrapper/containers/Header'
import AppError from 'wrapper/containers/AppError'

const GenerateIFrame = (message, data) => {
    switch (message) {
        case `FRAME/CREATE_CHILD/${APP_ERROR_TAG}`:
            AppError(data)
            break
        case `FRAME/CREATE_CHILD/${LAUNCHER_TAG}`:
            Launcher(data)
            break
        case `FRAME/CREATE_CHILD/${MENU_TAG}`:
            Menu(data)
            break
        case `FRAME/CREATE_CHILD/${PROMPT_TAG}`:
            Prompt(data)
            break
        case `FRAME/CREATE_CHILD/${HEADER_TAG}`:
            Header(data)
            break
        default:
        // do nothing
    }
}

export default GenerateIFrame
